<div class="shadow-layer">
  <img [ngClass]="{animate}"
       [src]="getSrc()"
       alt="Epson Rewards logo">
</div>
